// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Import Pages
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';
import NewAccordion from "../../../../components/Accordion/NewAccordion";
import DataTableLoader from "../../../../components/ContentLoader/DataTableLoader";

// Import Helpers
import { convertToDateFormat, getUserDetailFromJwt } from '../../../../helpers/helper';

// Import Icons
import emptyPageIcon from "../../../../assets/icons/configurationIcons/empty-page.svg";
import showLogsIcon from "../../../../assets/icons/configurationIcons/show-logs.svg";
import reRunIcon from "../../../../assets/icons/configurationIcons/rerun-operation.svg";
import goAutom from "../../../../assets/icons/configurationIcons/go-autom-on-monitoring.svg";
import quePoolIcon from "../../../../assets/icons/configurationIcons/que-pool-icon.svg";
import noneQuePoolIcon from "../../../../assets/icons/configurationIcons/none-queue-pool-icon.svg";
import automFlow from '../../../../assets/icons/configurationIcons/autom-flow.svg';
import actionFlow from '../../../../assets/icons/configurationIcons/action-flow.svg';
import RefreshIcon from '@material-ui/icons/Refresh';

// Import Material UI
import { CircularProgress, Tooltip } from "@material-ui/core";

// Import Services
import QueueService from "../../../../services/QueueService/QueueService";
import LogService from "../../../../services/LogService/LogService";

// Import Recoil
import { alertState, personalizationState, rolePermission } from "../../../../recoil-store/recoil-state";

let deletedIds = [];
let setSelectedRow;
const admin_user_id = "63240945-f9a7-497f-a132-c0c3b7aa32c7";

function HistoryMonitor(props) {
    // const doneList = useRecoilValue(doneListState);
    const [refresh, setRefresh] = useState({});
    const [refreshColumns, setRefreshColumns] = useState(false);
    const [loadingAdvancedlog, setLoadingAdvancedLog] = useState([]);
    const personalization = useRecoilValue(personalizationState);
    const role = useRecoilValue(rolePermission);

    const [openDelete, setOpenDelete] = useState(false);
    const setAlert = useSetRecoilState(alertState);

    const {
        loading,
        setSearchKeyData,
        setSearchData,
        searchData,
        setCustomColumn,
        customColumn,
        fetchData,
        setLoading,
        outCurrentPage,
        searchQueueData,
        showType,
        dataCount,
        automDataCount,
        fetchQueueDetails,
        setSearchQueueData,
        handleSelectOperation,
        handleRetryOperation,
        fetchQueueData,
        isRetryInProgress
    } = props;
    const { t } = useTranslation();

    const [currentPage, setCurrentPage] = useState(1);
    const [numberOfRows, setNumberOfRows] = useState(10);
    const [customItemColumns, setCustomItemColumns] = useState([]);
    const [showAdvancedLogs, setAdvancedLogs] = useState(false);
    const label = "MESSAGES.MONITORING.";
    useEffect(() => {
        let userDetail = getUserDetailFromJwt();
        if (userDetail && userDetail.role && userDetail.role.length) {
            if (userDetail.role.find(x => x.id === admin_user_id)) {
                setAdvancedLogs(true);
            } else {
                setAdvancedLogs(false);
            }
        } else {
            setAdvancedLogs(false);
        }

    }, []);

    // useEffect(() => {
    //     fetchData(0, 8).then(() => true);
    // }, [doneList]);

    const deleteHistory = async () => {
        setLoading(true);
        let ids = deletedIds;
        const response = await QueueService.deleteQueues(ids);
        if (response) {
            if (response.status) {
                setSelectedRow([]);
                fetchData('["COMPLETED","CANCELED", "FAILED"]', 0, true).then(() => true);
            }
            setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.MONITORING.DELETED-SUCCESSFULLY'), severity: response.status ? 'success' : 'error' }))
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoading(false);
    };

    const downloadAdvancedLogs = async (operation_id) => {
        setLoadingAdvancedLog((pre) => {
            let newLoading = pre
            newLoading.push(operation_id)
            return newLoading
        })
        setRefreshColumns((pre) => !pre)
        const result = await LogService.downloadAdvancedLogs(operation_id);
        setLoadingAdvancedLog((pre) => {
            let newLoading = pre
            newLoading = newLoading.filter((item) => item !== operation_id)
            return newLoading
        })
        setRefreshColumns((pre) => !pre)
        if (!result) {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        } else if (!result.status) {
            let message;
            if (result.message.includes('System error:')) {
                message = result.message.split('System error:')[1]
            } else {
                message = t("MESSAGES.MONITORING." + result.message)
            }
            setAlert(alert => ({ ...alert, show: true, message, severity: 'error' }))
        } else {
            const fileName = new Date().getTime().toString();
            // json data has been made pretty-printed
            const json = JSON.stringify(result.data, null, 2);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName + ".json";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    const showColumn = () => {
        switch (showType) {
            case "singleView":
                return [
                    {
                        id: 1,
                        name: "id",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return (
                                        <span className='index-number' >{searchData[dataIndex].index}.</span>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "name",
                        label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    let loadingLogs
                                    if (searchData[dataIndex].logs_status && searchData[dataIndex].logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                            {
                                                <span
                                                    style={{ color: "#4a4a4a", textDecoration: "none", cursor: "pointer", whiteSpace: "pre" }}
                                                    onClick={() => {
                                                        if (loadingLogs) {
                                                            return
                                                        }
                                                        handleSelectOperation(searchData[dataIndex])
                                                    }}
                                                >
                                                    {searchData[dataIndex]?.autom_name}
                                                </span>
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 3,
                        name: "operation_status",
                        label: t("MESSAGES.MONITORING.OPERATION-STATUS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return (
                                        <p className={`info-text operation-status-container operation-status-container-${searchData[dataIndex]?.operation_status?.toLowerCase()}`}>
                                            {/* {searchData[dataIndex]?.operation_status} */}
                                            {
                                                searchData[dataIndex]?.operation_status ?
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                                        <div className={`operation-status-dot-${searchData[dataIndex]?.operation_status?.toLowerCase()}`} style={{
                                                            borderRadius: "10px",
                                                            width: "6px", height: "6px",
                                                        }}></div>
                                                        {/* {searchData[dataIndex].operation_status.toLowerCase()} */}
                                                        {searchData[dataIndex].operation_status.charAt(0) + searchData[dataIndex].operation_status.slice(1).toLowerCase()}
                                                    </div>
                                                    : "-"
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 4,
                        name: "run_by",
                        label: t("MESSAGES.MONITORING.RUN-BY"),
                        options: {
                            filter: true, sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchData[dataIndex]) {
                                    return <p className='info-text'>{searchData[dataIndex].run_by}</p>
                                }
                            },
                        }
                    },
                    {
                        id: 5,
                        name: "parent_queue_pool",
                        label: t("MESSAGES.MONITORING.QUEUE-POOL"),
                        options: {
                            filter: true, sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return (
                                        <p className='info-text'>{searchData[dataIndex].pool_name ? searchData[dataIndex].pool_name : "-"}</p>
                                    )
                                }
                            },
                        }
                    },
                    {
                        id: 6,
                        name: "created_at",
                        label: t("MESSAGES.MONITORING.CREATED-ON"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return convertToDateFormat(searchData[dataIndex]?.created_on, personalization.date_format);
                                }
                            },
                        },
                    },
                    {
                        id: 7,
                        name: "finished_at",
                        label: t("MESSAGES.MONITORING.FINISHED-AT"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchData && searchData[dataIndex]) {
                                    return convertToDateFormat(searchData[dataIndex]?.finished_at, personalization.date_format);
                                }
                            },
                        },
                    },
                    {
                        id: 8,
                        name: "actions",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex) => {
                                // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                                if (searchData[dataIndex]) {
                                    let loadingLogs, loadingAdvancedlogs
                                    if (searchData[dataIndex].logs_status && searchData[dataIndex].logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    if (loadingAdvancedlog.length) {
                                        loadingAdvancedlogs = loadingAdvancedlog.find((item) => item === searchData[dataIndex].operation_id)
                                    }
                                    return (
                                        <div className='monitoring-option-container flow-configure-container'>
                                            <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 25px 0 10px" }}></div>
                                            {/* <Tooltip title={t(label + `OPEN-AUTOM`)} placement="top"> */}
                                            <Tooltip title={t(`MESSAGES.MONITORING.LOG-DETAIL${loadingLogs ? "-PROCESSING" : ""}`)} placement="top">
                                                {loadingLogs ? <CircularProgress size={16} /> : <img alt="log-detail" onClick={() => handleSelectOperation(searchData[dataIndex])} className='flow-option-img' src={showLogsIcon} />}
                                            </Tooltip>
                                            <Tooltip title={t('MESSAGES.MONITORING.GO-TO-AUTOM')} placement="top">
                                                <Link
                                                    className='flow-option-img'
                                                    data-test="autom-link"
                                                    to={`/automs/${searchData[dataIndex]?.autom_id}/autom/edit`}
                                                >
                                                    <img alt="go-autom" className='flow-option-img' src={goAutom} />
                                                </Link >
                                            </Tooltip>
                                            {searchData[dataIndex]?.operation_status === "FAILED" && searchData[dataIndex]?.trigger_type !== "Manual Trigger" && (
                                                <Tooltip title={t('MESSAGES.MONITORING.RETRY-OPERATION')} placement="top">
                                                    <img alt="retry-icon" onClick={() => handleRetryOperation(searchData[dataIndex].operation_id)}
                                                        id={`retry-${searchData[dataIndex].operation_id}`} className="flow-option-img" src={reRunIcon} />
                                                </Tooltip>
                                            )}
                                            {/* {loadingAdvancedlogs ?
                                                <CircularProgress size={16} />
                                                : <Tooltip title={t(`MESSAGES.MONITORING.DOWNLOAD-ADVANCED-LOGS${loadingLogs ? "-PROCESSING" : ""}`)} placement="top">
                                                    <img style={{ opacity: loadingLogs ? "0.5" : "1" }} onClick={() => {
                                                        if (loadingLogs) return
                                                        downloadAdvancedLogs(searchData[dataIndex].operation_id)
                                                    }} className='flow-option-img'
                                                        src={donloadLogIcon} />
                                                </Tooltip >} */}

                                        </div >
                                    );
                                }
                            },
                        },
                    },
                ];
                break;
            case "automListView":
                return [
                    {
                        id: 1,
                        name: "image_path",
                        label: "",
                        display: "flex",
                        options: {
                            filter: true, sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData[dataIndex]) {
                                    return <div className="queue-image-container" style={{ display: "flex", gap: "10px" }}>
                                        <Tooltip title={searchQueueData[dataIndex].type} placement="top">
                                            <div className={`autom-group-image`} style={{ backgroundColor: `${searchQueueData[dataIndex].type === "Autom" ? "#4F6E90" : "#F4BB66"} ` }}>
                                                {searchQueueData[dataIndex].type === "Autom" ?
                                                    <img draggable={false} style={{ width: "24px", height: "24px" }} src={automFlow} /> :
                                                    <img draggable={false} style={{ width: "30px", height: "22px" }} src={actionFlow} />}
                                            </div>
                                        </Tooltip >
                                    </div >
                                }
                            },
                        }
                    },
                    {
                        id: 1,
                        name: "name",
                        label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchQueueData && [dataIndex]) {
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                            {searchQueueData[dataIndex]?.name ?
                                                <span style={{ whiteSpace: "pre" }}>
                                                    {searchQueueData[dataIndex]?.name}
                                                </span>
                                                : <span style={{ color: "#AEAEAE" }}>{t("MESSAGES.MONITORING.NONE-QUEUE")}</span>
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "group_name",
                        label: t("CONTENT.AUTOMS-LIST.GROUP-NAME"),
                        options: {
                            filter: true, sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return <p className={`info-text ${searchQueueData[dataIndex].autom_group_name ? "group-text" : ""}`}
                                        style={searchQueueData[dataIndex].autom_group_color && {
                                            backgroundColor: `rgba${searchQueueData[dataIndex].autom_group_color?.slice(4, -2)} 0.3)`,
                                            border: `1px solid ${searchQueueData[dataIndex].autom_group_color}`, color: `${searchQueueData[dataIndex].autom_group_color}`
                                        }}>
                                        {searchQueueData[dataIndex].autom_group_name ?
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                                <div style={{
                                                    border: `1px solid ${searchQueueData[dataIndex].autom_group_color}`, borderRadius: "10px", backgroundColor: `${searchQueueData[dataIndex].autom_group_color}`,
                                                    width: "6px", height: "6px"
                                                }}></div>
                                                <span className="overflow-text">{searchQueueData[dataIndex].autom_group_name}</span>
                                            </div>
                                            : "-"}
                                    </p>
                                }
                            },
                        }
                    },
                    {
                        id: 3,
                        name: "status",
                        label: t("MESSAGES.MONITORING.TOTAL-OPERATIONS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return <div className='queue-count-box count-history'>
                                        <p className='queue-count'>{searchQueueData[dataIndex].operation_count > 999 ? `+999` : searchQueueData[dataIndex].operation_count}</p>
                                    </div>;
                                }
                            },
                        },
                    },
                    {
                        id: 7,
                        name: "refresh",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return <RefreshIcon onClick={() => setRefresh({ index: dataIndex, time: new Date() })} className='monitoring-refresh-icon' style={{ marginRight: "20px" }} />
                                    // return loading ? <CircularProgress size={16} /> : <RefreshIcon onClick={() => setRefresh({ index: dataIndex, time: new Date() })} className='monitoring-refresh-icon' style={{ marginRight: "20px" }} />
                                }
                                return "-"
                            },
                        },
                    },
                ];
                break;
            default:
                return [
                    {
                        id: 1,
                        name: "image",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                return (
                                    <div className="queue-image-container">
                                        <img className="queue-image" src={dataIndex === 0 ? noneQuePoolIcon : quePoolIcon} />
                                    </div>
                                );
                            }
                        },
                    },
                    {
                        id: 1,
                        name: "name",
                        label: t("MESSAGES.MONITORING.QUEUE-NAME"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, rowIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                            {searchQueueData[dataIndex]?.pool_name ?
                                                <span>
                                                    {searchQueueData[dataIndex]?.pool_name}
                                                </span>
                                                : <span style={{ color: "#AEAEAE" }}>{t("MESSAGES.MONITORING.NONE-QUEUE")}</span>
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 5,
                        name: "status",
                        label: t("MESSAGES.MONITORING.TOTAL-OPERATIONS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return <div className='queue-count-box count-history'>
                                        <p className='queue-count'>{searchQueueData[dataIndex].operation_count > 999 ? `+999` : searchQueueData[dataIndex].operation_count}</p>
                                    </div>;
                                }
                            },
                        },
                    },
                    {
                        id: 6,
                        name: "created_at",
                        label: t("MESSAGES.MONITORING.CREATED-ON"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex] && searchQueueData[dataIndex]?.updated_at) {
                                    return convertToDateFormat(searchQueueData[dataIndex]?.updated_at, personalization.date_format);
                                }
                                return "-"
                            },
                        },
                    },
                    {
                        id: 7,
                        name: "refresh",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex) => {
                                if (searchQueueData && searchQueueData[dataIndex]) {
                                    return <RefreshIcon onClick={() => setRefresh({ index: dataIndex, time: new Date() })} className='monitoring-refresh-icon' style={{ marginRight: "20px" }} />
                                    // return loading ? <CircularProgress size={16} /> : <RefreshIcon onClick={() => setRefresh({ index: dataIndex, time: new Date() })} className='monitoring-refresh-icon' style={{ marginRight: "20px" }} />
                                }
                                return "-"
                            },
                        },
                    },
                ];
                break;
        }
    }

    const showChildColumn = () => {
        switch (showType) {
            case "longQueue":
                return [
                    {
                        id: 1,
                        name: "id",
                        label: "",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <span className='index-number' >{item.index}.</span>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "name",
                        label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    let loadingLogs
                                    if (item.logs_status && item.logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    return (
                                        <p className='bold-overflow-text info-text' style={{ maxHeight: "32px" }}>
                                            {
                                                <span
                                                    style={{ color: "#4a4a4a", textDecoration: "none", cursor: "pointer", whiteSpace: "pre" }}
                                                    onClick={() => {
                                                        if (loadingLogs) {
                                                            return
                                                        }
                                                        handleSelectOperation(item)
                                                    }}
                                                >
                                                    {item?.autom_name}
                                                </span>
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 3,
                        name: "operation_status",
                        label: t("MESSAGES.MONITORING.OPERATION-STATUS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <p className={`info-text operation-status-container operation-status-container-${item?.operation_status?.toLowerCase()}`}>
                                            {/* {item?.operation_status} */}
                                            {
                                                item?.operation_status ?
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                                        <div className={`operation-status-dot-${item?.operation_status?.toLowerCase()}`} style={{
                                                            borderRadius: "10px",
                                                            width: "6px", height: "6px",
                                                        }}></div>
                                                        {/* {item.operation_status.toLowerCase()} */}
                                                        {item.operation_status.charAt(0) + item.operation_status.slice(1).toLowerCase()}
                                                    </div>
                                                    : "-"
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 4,
                        name: "run_by",
                        label: t("MESSAGES.MONITORING.RUN-BY"),
                        options: {
                            filter: true, sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return <p className='info-text'>{item.run_by}</p>
                                }
                            },
                        }
                    },
                    {
                        id: 5,
                        name: "created_at",
                        label: t("MESSAGES.MONITORING.CREATED-ON"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return convertToDateFormat(item?.created_on, personalization.date_format);
                                }
                            },
                        },
                    },
                    {
                        id: 6,
                        name: "finished_at",
                        label: t("MESSAGES.MONITORING.FINISHED-AT"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return convertToDateFormat(item?.finished_at, personalization.date_format);
                                }
                            },
                        },
                    },
                    {
                        id: 7,
                        name: "actions",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, item) => {
                                // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                                if (item) {
                                    let loadingLogs, loadingAdvancedlogs
                                    if (item.logs_status && item.logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    if (loadingAdvancedlog.length) {
                                        const isFind = loadingAdvancedlog.find((item) => item === item.operation_id)
                                        loadingAdvancedlogs = isFind
                                    }
                                    return (
                                        <div className='monitoring-option-container flow-configure-container'>
                                            <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 25px 0 10px" }}></div>
                                            <Tooltip title={t(`MESSAGES.MONITORING.LOG-DETAIL${loadingLogs ? "-PROCESSING" : ""}`)} placement="top">
                                                {loadingLogs ? <CircularProgress size={16} /> : <img onClick={() => handleSelectOperation(item)} className='flow-option-img' src={showLogsIcon} />}
                                            </Tooltip>
                                            <Tooltip title={t('MESSAGES.MONITORING.GO-TO-AUTOM')} placement="top">
                                                <Link
                                                    className='flow-option-img'
                                                    data-test="autom-link"
                                                    to={`/automs/${item?.autom_id}/autom/edit`}
                                                >
                                                    <img className='flow-option-img' src={goAutom} />
                                                </Link >
                                            </Tooltip>
                                            {/* {loadingAdvancedlogs ?
                                                <CircularProgress size={16} />
                                                : <Tooltip title={t(`MESSAGES.MONITORING.DOWNLOAD-ADVANCED-LOGS${loadingLogs ? "-PROCESSING" : ""}`)} placement="top">
                                                    <img style={{ opacity: loadingLogs ? "0.5" : "1" }} onClick={() => {
                                                        if (loadingLogs) return
                                                        downloadAdvancedLogs(item.operation_id)
                                                    }} className='flow-option-img'
                                                        src={donloadLogIcon} />
                                                </Tooltip>} */}
                                        </div >
                                    );
                                }
                            },
                        },
                    },
                ]
                break;
            case "automListView":
                return [
                    {
                        id: 1,
                        name: "id",
                        label: "",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <span className='index-number' >{item.index}.</span>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 2,
                        name: "created_on",
                        label: t("MESSAGES.MONITORING.STARTED-AT"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return convertToDateFormat(item?.created_on, personalization.date_format);
                                }
                            },
                        },
                    },
                    {
                        id: 3,
                        name: "finished_at",
                        label: t("MESSAGES.MONITORING.FINISHED-AT"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return convertToDateFormat(item?.finished_at, personalization.date_format);
                                }
                            },
                        },
                    },
                    {
                        id: 4,
                        name: "operation_status",
                        label: t("MESSAGES.MONITORING.OPERATION-STATUS"),
                        options: {
                            filter: true,
                            sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item) {
                                    return (
                                        <p className={`info-text operation-status-container operation-status-container-${item?.operation_status?.toLowerCase()}`}>
                                            {/* {item?.operation_status} */}
                                            {
                                                item?.operation_status ?
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "7px" }}>
                                                        <div className={`operation-status-dot-${item?.operation_status?.toLowerCase()}`} style={{
                                                            borderRadius: "10px",
                                                            width: "6px", height: "6px",
                                                        }}></div>
                                                        {/* {item.operation_status.toLowerCase()} */}
                                                        {item.operation_status.charAt(0) + item.operation_status.slice(1).toLowerCase()}
                                                    </div>
                                                    : "-"
                                            }
                                        </p>
                                    );
                                }
                            },
                        },
                    },
                    {
                        id: 5,
                        name: "integration_type",
                        label: t("MESSAGES.MONITORING.TRIGGER-TYPE"),
                        options: {
                            filter: true, sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                // if (item && item.integration_type) {
                                //     // return <p className='info-text'>{item.integration_type === "STANDARD" ? "Manual Trigger" : item.integration_type.toLowerCase()}</p>
                                //     return <p className='info-text'>{t(`CONTENT.AUTOMS-LIST.TRIGGER-${item.trigger_type ? item.trigger_type?.toUpperCase() : "STANDARD"}`)}</p>
                                // }
                                if (item) {
                                    let trigger_type = 'Manual';
                                    if (item.operation_trigger_type) {
                                        trigger_type = item.operation_trigger_type;
                                    } else if (item.trigger_type) {
                                        trigger_type = item.trigger_type;
                                    }
                                    return <p className='info-text capitalize-text'>{trigger_type === "Manual Trigger" ? "Manual" : trigger_type}</p>
                                }
                            },
                        }
                    },
                    {
                        id: 6,
                        name: "run_by",
                        label: t("MESSAGES.MONITORING.RUN-BY"),
                        options: {
                            filter: true, sort: true,
                            customBodyRenderLite: (dataIndex, item) => {
                                if (item && item.run_by) {
                                    return <p className='info-text'>{item.run_by}</p>
                                }
                            },
                        }
                    },
                    {
                        id: 7,
                        name: "actions",
                        label: "",
                        display: "flex",
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRenderLite: (dataIndex, item) => {
                                // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                                if (item) {
                                    let loadingLogs, loadingAdvancedlogs
                                    if (item.logs_status && item.logs_status !== "COMPLETED") {
                                        loadingLogs = true
                                    }
                                    if (loadingAdvancedlog.length) {
                                        const isFind = loadingAdvancedlog.find((item) => item === item.operation_id)
                                        loadingAdvancedlogs = isFind
                                    }
                                    return (
                                        <div className='monitoring-option-container flow-configure-container'>
                                            <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 25px 0 10px" }}></div>
                                            <Tooltip title={t(`MESSAGES.MONITORING.LOG-DETAIL${loadingLogs ? "-PROCESSING" : ""}`)} placement="top">
                                                {loadingLogs ? <CircularProgress size={16} /> : <img onClick={() => handleSelectOperation(item)} className='flow-option-img' src={showLogsIcon} />}
                                            </Tooltip>
                                            <Tooltip title={t('MESSAGES.MONITORING.GO-TO-AUTOM')} placement="top">
                                                <Link
                                                    className='flow-option-img'
                                                    data-test="autom-link"
                                                    to={`/automs/${item?.autom_id}/autom/edit`}
                                                >
                                                    <img className='flow-option-img' src={goAutom} />
                                                </Link >
                                            </Tooltip>
                                            {/* {loadingAdvancedlogs ?
                                                <CircularProgress size={16} />
                                                : <Tooltip title={t(`MESSAGES.MONITORING.DOWNLOAD-ADVANCED-LOGS${loadingLogs ? "-PROCESSING" : ""}`)} placement="top">
                                                    <img style={{ opacity: loadingLogs ? "0.5" : "1" }} onClick={() => {
                                                        if (loadingLogs) return
                                                        downloadAdvancedLogs(item.operation_id)
                                                    }} className='flow-option-img'
                                                        src={donloadLogIcon} />
                                                </Tooltip>} */}

                                        </div >
                                    );
                                }
                            },
                        },
                    },
                    // {
                    //     id: 1,
                    //     name: "info",
                    //     label: "",
                    //     options: {
                    //         filter: true,
                    //         sort: true,
                    //         customBodyRenderLite: (dataIndex, item) => {
                    //             if (item) {
                    //                 return (
                    //                     <div className={`operation-status-dot-${item?.operation_status?.toLowerCase()}`} style={{
                    //                         borderRadius: "10px",
                    //                         width: "9px", height: "9px",
                    //                     }}></div>
                    //                 );
                    //             }
                    //         },
                    //     },
                    // },
                    // {
                    //     id: 2,
                    //     name: "name",
                    //     label: t("MESSAGES.MONITORING.HISTORY"),
                    //     options: {
                    //         filter: true,
                    //         sort: true,
                    //         customBodyRenderLite: (dataIndex, item) => {
                    //             if (item) {
                    //                 return (
                    //                     <p className='bold-overflow-text info-text' style={{ maxHeight: "32px", maxWidth: "120px" }}>
                    //                         {
                    //                             <div
                    //                                 style={{ color: "#4a4a4a", textDecoration: "none", cursor: "pointer" }}
                    //                                 onClick={() => handleSelectOperation(item)}
                    //                             >
                    //                                 {item?.autom_name}
                    //                             </div>
                    //                         }
                    //                     </p>
                    //                 );
                    //             }
                    //         },
                    //     },
                    // },
                    // {
                    //     id: 2,
                    //     name: "actions",
                    //     label: "",
                    //     display: "flex",
                    //     options: {
                    //         filter: false,
                    //         sort: false,
                    //         customBodyRenderLite: (dataIndex, item) => {
                    //             // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                    //             if (item) {
                    //                 return (
                    //                     <div className='monitoring-option-container flow-configure-container' style={showType === "automListView" && {
                    //                         width: "fit-content", gap: "22px"
                    //                     }}>
                    //                         <div style={{ border: "1px solid #EEEEEE", height: "50px", margin: "0 20px 0 0" }}></div>
                    //                         {/* <Tooltip title={t(label + `OPEN-AUTOM`)} placement="top"> */}
                    //                         <Tooltip title={t('MESSAGES.MONITORING.LOG-DETAIL')} placement="top">
                    //                             <img onClick={() => handleSelectOperation(item)} className='flow-option-img' src={showLogsIcon} />
                    //                         </Tooltip>
                    //                         <Tooltip title={t('MESSAGES.MONITORING.GO-TO-AUTOM')} placement="top">
                    //                             <Link
                    //                                 className='flow-option-img'
                    //                                 data-test="autom-link"
                    //                                 to={`/automs/${item?.autom_id}/autom/edit`}
                    //                             >
                    //                                 <img className='flow-option-img' src={goAutom} />
                    //                             </Link>
                    //                         </Tooltip >
                    //                         <Tooltip title={t('MESSAGES.MONITORING.DOWNLOAD-ADVANCED-LOGS')} placement="top">
                    //                             <img className='flow-option-img' onClick={() => downloadAdvancedLogs(item.operation_id)}
                    //                                 src={donloadLogIcon} />
                    //                         </Tooltip >
                    //                     </div >
                    //                 );
                    //             }
                    //         },
                    //     },
                    // },
                ]
                break;

            default:
                return
                break;
        }
    }
    useEffect(() => {
        let column = showColumn()
        const childColumn = showChildColumn()
        setCustomColumn(column);
        setCustomItemColumns(childColumn)
        setSearchKeyData(["autom_name", "autom_type", "created_on", "operation_status", "pool_name"]);
    }, [searchData, showType, searchQueueData, refreshColumns]);

    return (<>
        <div id="monitoring-table-container" className="table-container">
            {/* {loading ? <DataTableLoader /> : <> */}
            {loading ? <CircularProgress className="circular-progress-icon" size={40} /> : <>
                {!dataCount && showType === "singleView" &&
                    <div className='empty-page-info-container'>
                        <img src={emptyPageIcon} />
                        <p className='info-text'>{t('MESSAGES.MONITORING.EMPTY-OPERATIONS')}</p>
                    </div>
                }
                {showType === "singleView" && searchData && searchData.length ? searchData.map((data, index) => {
                    return <NewAccordion
                        setSearchData={setSearchData} customColumns={customColumn}
                        data={data} index={index} setCustomColumn={setCustomColumn} gridColumns={"0.4fr 1fr 1fr 1fr 1fr 1fr 1fr"} />
                }) : ""}
                {showType !== "singleView" && !searchQueueData?.length &&
                    <div className='empty-page-info-container'>
                        <img src={emptyPageIcon} />
                        <p className='info-text'>{t('MESSAGES.MONITORING.EMPTY-OPERATIONS')}</p>
                    </div>
                }
                {showType !== "singleView" && searchQueueData && searchQueueData.length ? searchQueueData.map((data, index) => {
                    return <NewAccordion
                        setSearchData={setSearchQueueData} customColumns={customColumn}
                        data={data} index={index} setCustomColumn={setCustomColumn}
                        showType={showType}
                        fetchChildItems={fetchQueueDetails}
                        gridColumns={"0.15fr 1fr 1fr 1fr"}
                        childGridColumns={"0.4fr 1fr 1fr 1fr 1fr 1fr"}
                        isAccordion={true} from={"history"} customItemColumns={customItemColumns} refresh={refresh} />
                }) : ""}</>}
            {/* {["singleView", "automListView"].includes(showType) ?
                <Pagination totalItems={showType === "singleView" ? dataCount : automDataCount} callFetch={showType === "singleView" ? fetchData : fetchQueueData}
                    showType={showType} outItemsPerPageLimit={[10, 25, 50, 100]} /> : ""} */}
            {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete} message={t(label + "DELETE-MESSAGE")} deleteFunc={deleteHistory} />}
        </div>
    </>
    );
}

export default HistoryMonitor;
